export class DocumentPanelListConstants{
    public static readonly PanelList_DisplayAssignedQas: number = 0;
    public static readonly PanelList_DisplayAssignedDocControls: number = 1;
    public static readonly PanelList_DisplayCollaborators: number = 2;
    public static readonly PanelList_DisplayAssignedAdmin: number = 3;
    public static readonly PanelList_DisplayApprovers: number = 4;
    public static readonly PanelList_DisplayReviewers: number = 5;
    public static readonly PanelList_DisplayInternalClientContacts: number = 6;

}